/**
 * Mobile menu
 */
const mobile_menu = (args) => {
    // setup args
    let header = args.header;
    let supplementary = args.supplementary;
    let main = args.main;
    let menu = args.menu;
    let toggles = args.toggles;
    let backdrops = args.backdrops;
    const animationDuration = 200;

    // validate
    if (!menu || !toggles.length) {
        // console.log('Invalid args');
        return;
    }

    // wrapper; closes the menu using tools
    const closeMenu = (toggle = false) => {
        H_Tools.mobilemenu.closeMenu(menu, toggles, animationDuration, toggle);
    };

    // toggle click
    const handleToggle = (e) => {
        // console.log('Menu button clicked...');

        let toggle = e.target.closest('.js-menu-toggle');

        if (document.documentElement.classList.contains('-is-active-menu')) {
            closeMenu(toggle);
        } else {
            H_Tools.mobilemenu.openMenu(toggles);
        }
    };

    const initOutsideFocus = (el) => {
        H_Tools.mobilemenu.makeOutsideFocusCloseMenu(
            menu,
            toggles,
            el,
            animationDuration
        );
    };

    const init = () => {
        // close on anchor link
        const anchorLinks = menu.querySelectorAll('a[href*="#"]');
        for (let i = 0; i < anchorLinks.length; i++) {
            if (anchorLinks[i].getAttribute('href') !== '#') {
                anchorLinks[i].addEventListener('click', closeMenu);
            }
        }

        for (let i = 0; i < toggles.length; i++) {
            toggles[i].addEventListener('click', handleToggle);
        }

        for (let i = 0; i < backdrops.length; i++) {
            backdrops[i].addEventListener('click', closeMenu);
        }

        // Close the menu with ESC key
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            var isEscape = false;
            if ('key' in evt) {
                isEscape = evt.key === 'Escape' || evt.key === 'Esc';
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                closeMenu();
                H_Tools.mobilemenu.focusOpeningToggle(menu);
            }
        };

        if (header) {
            initOutsideFocus(header);
        }
        if (supplementary) {
            initOutsideFocus(supplementary);
        }
        if (main) {
            initOutsideFocus(main);
        }
    };

    init();

    return this;
};

mobile_menu({
    header: document.querySelector('.js-site-header'),
    supplementary: document.querySelector('.js-site-supplementary'),
    main: document.querySelector('.js-site-main'),
    menu: document.querySelector('.js-mobile-menu'),
    toggles: document.querySelectorAll('.js-menu-toggle'),
    backdrops: document.querySelectorAll('.js-mobile-menu-backdrop'),
});
